<template>
  <select
    class="form-control"
    :id="id"
    :disabled="isDisabled"
    :value="localValue"
    @change="handleValueUpdate($event.target.value)"
  >
    <option :value="null" disabled>{{ placeholder }}</option>
    <option
      v-for="option in listOptions"
      :key="option.value"
      :value="option.value"
    >
      {{ option.text }}
    </option>
  </select>
</template>

<script>
import { useReactiveModelMixin } from '../../mixins'

export default {
  name: 'NxSelectInstancia',
  mixins: [useReactiveModelMixin('value')],
  props: {
    isDisabled: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: 'selectInstancia'
    },
    placeholder: {
      type: String,
      default: 'Selecione a instância'
    }
  },
  data () {
    return {
      listOptions: [
        { value: 1, text: '1ª Instância' },
        { value: 2, text: '2ª Instância' },
        { value: 3, text: '3ª Instância' },
        { value: 4, text: '4ª Instância' }
      ]
    }
  },
  methods: {
    handleValueUpdate (val) {
      const parsed = parseInt(val, 10)
      this.localValue = isNaN(parsed) ? null : parsed
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/nexum/components/custom-selects/NxSelectInstancia.vue